import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useGlobalSnackbar } from "../contexts/SnackbarContext";
import useApi from "../hooks/useApi";
import { useTranslation } from "react-i18next";
import {
  Done,
  Translate,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";

const useStyles = makeStyles({
  content: {
    maxWidth: "300px",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    margin: "auto",
  },
  card: {
    margin: "auto",
    padding: "3%",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: "5%",
    margin: "auto",
  },
  text: {
    paddingBottom: "7%",
    textAlign: "left",
  },
  button: {
    width: "100%",
  },
  link: {
    marginTop: "1rem",
  },
  languageButton: {
    textTransform: "none",
    margin: "0.5rem 0.5rem 0 auto",
  },
});

const ForgotPassword = () => {
  const classes = useStyles();
  const api = useApi();

  const setGlobalSnackbar = useGlobalSnackbar();

  const [email, setEmail] = useState("");
  const { t, i18n } = useTranslation(["views", "common"]);
  const [open, setOpen] = useState(false);
  const anchorEl = useRef();

  const languages = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    { code: "fr", label: "Français" },
    { code: "it", label: "Italiano" },
  ];
  const currentLanguage = (
    i18n.resolvedLanguage ||
    i18n.language ||
    "it"
  ).split("-")[0];

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const res = await api("users/forgotpassword", "POST", {
      email,
      language:i18n.language
    });
    if (res.ok !== false) {
      setGlobalSnackbar({
        open: true,
        severity: "success",
        message: `${t("common:success.reset_password")}`,
      });
      return;
    }
    setGlobalSnackbar({
      open: true,
      severity: "error",
      message: `${t("common:errors.reset_password")}`,
    });
  };
  return (
    <div>
      <form className={classes.content} onSubmit={onSubmit}>
        <Card className={classes.card}>
          <div style={{ display: "flex" }}>
            <Button
              className={classes.languageButton}
              aria-controls="language-menu"
              aria-haspopup="true"
              onClick={() => setOpen(true)}
              ref={anchorEl}
              endIcon={open ? <KeyboardArrowUp />:<KeyboardArrowDown />}
            >
              <Translate />
            </Button>
          </div>
          <Menu
            id="language-menu"
            anchorEl={anchorEl?.current}
            keepMounted
            open={open}
            getContentAnchorEl={null}
            onClose={() => setOpen(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
          >
            {languages.map((lang) => (
              <MenuItem
                key={lang.code}
                selected={lang.code === currentLanguage}
                onClick={() => {
                  i18n.changeLanguage(lang.code);
                  setOpen(false);
                }}
              >
                {currentLanguage == lang.code ? (
                  <Done fontSize="small" />
                ) : (
                  <span style={{ width: 24 }} />
                )}
                {lang.label}
              </MenuItem>
            ))}
          </Menu>
          <CardHeader title={t("views:forgot_password.title")} />
          <CardContent>
            <Typography
              variant="body2"
              color="textSecondary"
              component="p"
              className={classes.text}
            >
              {t("views:forgot_password.subtitle")}
            </Typography>
            <div className={classes.field}>
              <TextField
                type="email"
                name="email"
                label="Email"
                required
                value={email}
                onChange={handleChange}
              />
            </div>
            <div>
              <Button
                type="submit"
                className={classes.button}
                variant="contained"
                color="primary"
              >
                {t("views:forgot_password.reset_password")}
              </Button>
            </div>
            <div>
              <Link to="/" className={classes.link}>
                <p>{t("views:forgot_password.back_login")}</p>
              </Link>
            </div>
          </CardContent>
        </Card>
      </form>
    </div>
  );
};

export default ForgotPassword;
